module.exports = __webpack_public_path__ + "img/1920_stores_img7.cde091d2.png";